import { FormattedMessage } from 'react-intl';
import { Value } from 'react-select';

import {
    DEBIT_CARD_TYPE,
    MANUAL_BANK_TRANSFER_TYPE,
    TRUELAYER_REPAYMENT_TYPE
} from '../EarlyRepaymentHelper';
import { PaymentMethodLogo } from './PaymentMethodLogo';
import styles from './PaymentMethodValue.module.css';

export class PaymentMethodValue extends Value {
    renderLabel() {
        const {
            value: { label, type }
        } = this.props;

        switch (type) {
            case DEBIT_CARD_TYPE:
                return (
                    <FormattedMessage
                        id="_.select_payment_method.card_option"
                        defaultMessage="Card ●●●● {cardLastDigits}"
                        values={{ cardLastDigits: label }}
                    />
                );
            case 'BANK_ACCOUNT':
                return (
                    <FormattedMessage
                        id="_.select_payment_method.bank_account_option"
                        defaultMessage="Account {accountNumber}"
                        values={{ accountNumber: label }}
                    />
                );
            case MANUAL_BANK_TRANSFER_TYPE:
                return (
                    <FormattedMessage
                        id="_.select_payment_method.manual_payment"
                        defaultMessage="Manual Bank Transfer"
                    />
                );
            case TRUELAYER_REPAYMENT_TYPE:
                return (
                    <FormattedMessage
                        id="_.select_payment_method.truelayer_repayment"
                        defaultMessage="Instant Bank Transfer"
                    />
                );
            default:
                return <>{label}</>;
        }
    }

    renderIcon() {
        const {
            value: { issuer, type }
        } = this.props;

        const logoStyle = styles.icon;

        return (
            <PaymentMethodLogo
                type={type}
                issuer={issuer}
                logoStyle={logoStyle}
            />
        );
    }

    render() {
        const icon = this.renderIcon();

        return (
            <div
                data-testid="selected-value"
                className={styles.PaymentMethodValue}
            >
                {icon}
                {super.render()}
            </div>
        );
    }
}
